(function () {
  "use strict";

  MultiUserDetailsSidebarCtrl.$inject = ['$scope', 'usersResource', 'mtypes', 'authView', '$rootScope', 'manageUsersGrouping', 'modalHelper', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('MultiUserDetailsSidebarCtrl', MultiUserDetailsSidebarCtrl);

  function MultiUserDetailsSidebarCtrl($scope, usersResource, mtypes, authView, $rootScope, manageUsersGrouping,
                                       modalHelper, trainerPrivilege) {
    $scope.activeCount = 0;
    $scope.archivedCount = 0;
    $scope.headerText = '';
    $scope.customFieldsGrouped = [];
    $scope.userGroupsGrouped = [];
    $scope.userCoursesGrouped = [];
    $scope.userSeriesGrouped = [];
    var userRole = trainerPrivilege.roles();

    $scope.canArchive = userRole.canArchiveUsers;
    $scope.canEditGroupMembership = userRole.canEditGroupMembership;
    $scope.canEditUserInfo = userRole.canEditUserInfo;

    function updateView() {
      var active = 0;
      var archived = 0;

      _.each($scope.selectedUsers, function (u) {
        if (u.status == mtypes.userStatus.active)
          active++;
        if (u.status == mtypes.userStatus.archived)
          archived++;
      });

      $scope.activeCount = active;
      $scope.archivedCount = archived;
      $scope.headerText = $scope.selectedUsers.length + ' users selected';

      $scope.userGroupsGrouped = manageUsersGrouping.groupUserGroups($scope.selectedUsers, $scope.userGroupLookup);
      $scope.userCoursesGrouped = manageUsersGrouping.groupUserCourses($scope.selectedUsers, $scope.courseLookup);
      $scope.userSeriesGrouped = manageUsersGrouping.groupUserSeries($scope.selectedUsers, $scope.seriesLookup);

      $scope.allCustomFields = _.map($scope.customUserFields, function (cf) {
        return manageUsersGrouping.setupCustomFieldValues($scope.selectedUsers, {
          id: cf.fieldIndex,
          name: cf.name
        });
      });
    }

    $scope.$watch('selectedUsers', function () {
      if ($scope.selectedUsers) {
        updateView();
      }
    });

    $scope.reactivateUsers = function () {
      $scope.$broadcast('genericServerActionShow', {
        title: 'Activate Users',
        warningText: 'Are you sure you want to activate ' + $scope.archivedCount + ' user(s)?',
        executingText: 'Activating ' + $scope.archivedCount + ' users(s)',
        confirmEventName: 'reactivateMultipleUsersEvent',
        okButtonId: 'mass-activate-users-ok-button',
        cancelButtonId: 'mass-activate-users-cancel-button'
      });
    };

    $scope.$on('reactivateMultipleUsersEvent', function (e, cb) {
      $scope.serverCallInProgress = true;
      usersResource.reactivateUsers(
        _.pluck($scope.selectedUsers, 'id'),
        function (result) {
          $scope.refreshSelectedUserInfo(function () {
            $scope.serverCallInProgress = false;
            cb();
            $scope.cleanSelection();
          });
        },
        function (err) {
          $scope.serverCallInProgress = false;
          cb();
          var message = 'There was an error reactivating the selected users. Please try again.';
          if (err && err.data && err.data.general)
            message = err.data.general;
          modalHelper.messageBox({title: 'Error Reactivating Users', message: message, buttons: [{label: 'OK'}]});
          return "cancelDefault";
        });
    });

    $scope.archiveUsers = function () {
      var warnings = {
        mySelf: 0,
        managerNonTraineeArchive: 0,
        accountOwnerArchive: 0,
        alreadyArchived: 0,
        getMessages: function () {
          var msg = [];
          if (this.mySelf) {
            msg.push("You cannot archive yourself.");
          }
          if (this.managerNonTraineeArchive) {
            msg.push("You do not have sufficient permission to archive " + this.managerNonTraineeArchive + " user(s).");
          }
          if (this.accountOwnerArchive) {
            msg.push("The account owner cannot be archived.");
          }
          if (this.alreadyArchived) {
            msg.push(this.alreadyArchived + " selected users are already archived.");
          }
          return msg;
        }
      };

      var idsToExclude = [];
      var isAdmin = authView.isAdministrator();

      _.each($scope.selectedUsers, function (u) {
        var exclude = false;
        if (u.status == mtypes.userStatus.archived) {
          warnings.alreadyArchived++;
          exclude = true;
        }
        else if (u.isOwner) {
          warnings.accountOwnerArchive++;
          exclude = true;
        }
        else if (!isAdmin && u.permissions != mtypes.userRole.trainee) {
          warnings.managerNonTraineeArchive++;
          exclude = true;
        }
        else if ($rootScope.userId == u.id) {
          warnings.mySelf++;
          exclude = true;
        }
        if (exclude)
          idsToExclude.push(u.id);
      });

      var modalData = {
        warnings: warnings.getMessages(),
        idsToExclude: idsToExclude,
        numberOfUsers: $scope.selectedUsers.length - idsToExclude.length
      };
      $scope.$broadcast('bulkArchiveEvent', modalData);
    };

    $scope.$on('bulkArchiveConfirmEvent', function (e, data, cb) {
      $scope.serverCallInProgress = true;
      var ids = _.difference(_.pluck($scope.selectedUsers, 'id'), data.idsToExclude);
      usersResource.archiveUsers(
        ids,
        function (result) {
          $scope.refreshSelectedUserInfo(function () {
            $scope.serverCallInProgress = false;
            cb();
            $scope.cleanSelection();
          });
        },
        function (err) {
          $scope.serverCallInProgress = false;
          cb();
          var message = 'There was an error archiving the selected users. Please try again.';
          if (err && err.data && err.data.general)
            message = err.data.general;
          modalHelper.messageBox({title: 'Error Archiving Users', message: message, buttons: [{label: 'OK'}]});
          return "cancelDefault";
        });
    });

    $scope.editCustomField = function (id) {
      var field = _.find($scope.allCustomFields, function (f) {
        return f.id == id;
      });
      $scope.editCustomFieldForMultipleUsers(_.clone(field));
    };

    $scope.editGroups = function () {
      $scope.editUsersGroups(_.clone($scope.userGroupsGrouped));
    };

    $scope.editCoursesAndSeries = function () {
      $scope.editUsersCoursesAndSeries(_.clone($scope.userCoursesGrouped), _.clone($scope.userSeriesGrouped));
    };

    $scope.isArrayEmpty = function (array) {
      return !array || array.length == 0;
    };

    $scope.showMassArchiveButton = function () {
      return $scope.canArchive &&
        $scope.activeCount > 0 &&
        ($rootScope.mfConfig.features.indexOf(mtypes.featureEntry.massTraineeActions) > 0 ||
        $rootScope.mfConfig.trialFeatures.indexOf(mtypes.featureEntry.massTraineeActions) > 0);
    };

    $scope.showMassReactivateButton = function () {
      return $scope.canArchive &&
        $scope.archivedCount > 0 &&
        ($rootScope.mfConfig.features.indexOf(mtypes.featureEntry.massTraineeActions) > 0 ||
        $rootScope.mfConfig.trialFeatures.indexOf(mtypes.featureEntry.massTraineeActions) > 0);
    };
  }

})();
